<script setup>
import DomainCard from './DomainCard.vue'

const { t, tm, rt, locale } = useI18n()
const { plainTm } = usePlainTm()
const route = useRoute()
const code = route.params.code
const suffix = `.${code.split('-')[1]}`

usePageSeo({
  title: t('domain.detail.title', { name: suffix }),
  description: t('domain.detail.description', { name: suffix }),
  bodyId: 'doamin-detail-page'
})

// Fetch domain product info
// Fetch suffix list for the search dropdown
const { data: prodata } = await useFetch('/api/domain-detail', {
  query: { code: route.params.code },
  default: () => ({ status: 0, data: [] })
})
const productInfo = computed(() => prodata.value.data)
// Fetch suffix list for the search dropdown
// const { data: suffixResp } = await useFetch("/api/domain-products", {
//   default: () => ({ status: 0, data: [] }),
// });
//
// const suffixData = computed(() => suffixResp.value?.data || []);
// const filteredProducts = computed(() => {
//   return suffixData.value[`${activeBrand.value}List`];
// });
const activeBrand = ref('hot')

const brandOptions = plainTm('domain.type').filter((t) => ['hot', 'country', 'newTop'].includes(t.key))
const hotDomains = computed(() => hotDomainData.value?.selectList || [])
const countryDomains = computed(
  () =>
    hotDomainData.value?.otherList?.filter((d) => ['.cn', '.us', '.hk', '.com.cn'].some((s) => d.name.includes(s))) ||
    []
)
const newTopDomains = computed(
  () =>
    hotDomainData.value?.otherList?.filter((d) => !['.cn', '.us', '.hk', '.com.cn'].some((s) => d.name.includes(s))) ||
    []
)

const activeTab = ref('hot')
const searchName = ref('')

function doSearch() {
  if (!searchName.value) {
    alert('Please enter domain name')
    return
  }
  navigateTo(`/check/domain?domain=${searchName.value}&suffix=.${code.split('-')[1]}`)
}
</script>

<template>
  <div>
    <div class="domain-detail-banner">
      <div class="inner-bound domain-banner">
        <!-- <h1 class="white-color domain-banner-title" style="text-align: center;">{{ t("domain.detail.title") }}</h1> -->
        <h1 class="white-color domain-banner-title" style="text-align: center">
          {{ productInfo?.abbrDescription || '' }}
        </h1>
        <div class="prices">
          <p class="white-color">
            {{ t('domain.detail.priceDesc') }}
            <span>${{ productInfo?.newPrice?.price1 || '0.00' }}</span>
          </p>
          <div class="more">
            <span>{{ t('btnText.morePrice') }} ></span>
            <ul>
              <li style="color: #333; margin: 0.02rem 0">
                1/Y {{ productInfo.currency }}{{ productInfo?.newPrice?.price1 || '0.00' }}
              </li>
              <li style="color: #333; margin: 0.02rem 0">
                2/Y {{ productInfo.currency }}{{ productInfo?.newPrice?.price3 || '0.00' }}
              </li>
              <li style="color: #333; margin: 0.02rem 0">
                3/Y {{ productInfo.currency }}{{ productInfo?.newPrice?.price5 || '0.00' }}
              </li>
              <li style="color: #333; margin: 0.02rem 0">
                4/Y {{ productInfo.currency }}{{ productInfo?.newPrice?.price10 || '0.00' }}
              </li>
            </ul>
          </div>
        </div>

        <div class="domain-input" style="margin-top: 0.18rem">
          <div>
            <input
              v-model="searchName"
              type="text"
              placeholder="Please enter domain name，for example, nicsrs"
              @keyup.enter="doSearch"
            />
          </div>
          <button @click="doSearch" class="domain-btn">
            {{ t('btnText.search') }}
          </button>
        </div>
      </div>
    </div>

    <section class="domain-code-card">
      <div class="inner-bound pt50 pb60">
        <h2 v-animate="'fadeInUp'" class="text-center">
          {{ t('domain.detail.topCardTitle', { name: code }) }}
        </h2>
        <div class="base-card domain-detail-card">
          <div class="card-left">
            <div>
              <h3>{{ productInfo.abbrDescription }}</h3>
              <p>{{ productInfo.description }}</p>
            </div>

            <div class="mt50">
              <a class="btn" href="https://console.nicsrs.com/login?redirectUrl=/check/domain" target="_blank">{{
                t('btnText.getStart')
              }}</a>
            </div>
          </div>
          <div class="card-right">
            <div
              class="right-text"
              style="border-radius: var(--border-radius); background-color: var(--theme-bg-color)"
            >
              {{ `.${code.split('-')[1]}` }}
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Products with brand filter -->
    <!-- <section class="brand-section">
      <div class="inner-bound pt50 pb60">
        <h2 class="text-section-title" v-animate="'fadeInUp'">
          {{ t("domain.hotSelling.title") }}
        </h2>
        <p>{{ t("domain.hotSelling.desc") }}</p>
        <div class="base-tabs mt20" v-animate="'fadeInUp'">
          <button
            v-for="brand in brandOptions"
            :key="brand.key"
            :class="['base-tab', { active: activeBrand === brand.key }]"
            @click="
              activeBrand = brand.key;
              refresh();
            "
          >
            {{ brand.name }}
          </button>
        </div>
        <div class="brand-product-grid">
          <div
            v-for="(product, index) in filteredProducts"
            :key="product.code"
            :class="['brand-product-card base-card', `delay-${index % 4}`]"
            v-animate="'fadeInUp'"
          >
            <DomainCard :product="product" />
          </div>
        </div>
      </div>
    </section> -->

    <!-- Why Choose Us -->
    <GridCard :items="plainTm('domain.why.items')" :title="t('domain.why.title')" :columns="2" isMuted />
    <!--Hot Domains  -->
    <section class="">
      <div class="inner-bound pt50 pb50">
        <h2 v-animate="'featInUp'" class="text-center">
          {{ t('domain.hotDomains.title') }}
        </h2>
        <p>{{ t('domain.hotDomains.desc') }}</p>
        <div class="free-tool">
          <div class="base-card">
            <div>
              <NuxtLink to="/dns-lookup">{{ t('domain.hotDomains.tools[0].name') }}</NuxtLink>
              <p>{{ t('domain.hotDomains.tools[0].desc') }}</p>
            </div>
          </div>
          <div class="base-card">
            <div>
              <NuxtLink to="/whois-lookup">{{ t('domain.hotDomains.tools[1].name') }}</NuxtLink>
              <p>{{ t('domain.hotDomains.tools[1].desc') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Domain Name Q&A -->

    <FAQ :faqItems="plainTm('domain.faq.faqItems')" :faqTitle="t('domain.faq.title')" />
  </div>
</template>
